import {ABSHtmlElement} from "../abstract/ABSHtmlElement.js";

class CharacterCounter extends ABSHtmlElement{

    private $textareaElement!: JQuery;
    private readonly onInput = ()=>{
        this.work(this.$textareaElement.val()! as string);
    }
    public constructor() {
        super();
        this.onAttributeChange('data-for', ()=>this.rebuildCallback());
    }
    static observedAttributes = ['data-for'];
    protected connectedCallback(): any {
        this.rebuildCallback();
        // this.onInput();
    }
    private rebuildCallback(){
        if(this.$textareaElement) this.$textareaElement.off('input', this.onInput);
        this.$textareaElement = $($(this).data('for'))
            .on('input', this.onInput);
    }
    private work(text: string){
        const charCount = text.length;
        this.innerHTML = `Символов: <b>${charCount}</b>`
    }
}

if(customElements.get('character-counter')) console.warn("Element local-time already exists... This shouldn't happen");
else customElements.define('character-counter', CharacterCounter)
